{
  "pages": {
    "reports": {
      "title": "Reports"
    }
  },
  "components": {
    "powerBiReport": {
      "error": {
        "title": "Failed to load report",
        "message": "Something went wrong while loading the report. Please try again later or contact support if the issue persists"
      }
    }
  }
}
